import { createTheme } from '@mui/material/styles';

// Palette and type carried over from mpindustries-web (src/styles/theme.js) so
// the CS tool reads as part of the same product. Health bands are the one
// addition: that theme has no green or amber, so sage and ochre were added
// alongside its own cancelColor, which serves as "at risk".
// Sólo color: las etiquetas viven en src/i18n (claves `bands.*` y
// `renewalStatus.*`) para que cambien con el idioma.
export const bands = {
  healthy: { color: '#4F7A5F' },
  watch:   { color: '#C9873F' },
  at_risk: { color: '#AE5B61' },
};

export const renewalStatuses = {
  confirmed:   { color: '#4F7A5F' },
  in_progress: { color: '#C9873F' },
  not_started: { color: '#AE5B61' },
  churned:     { color: '#847782' },
};

// Frecuencia de la suscripción: define cuánto se corre la renovación en el cierre de mes.
export const BILLING_FREQUENCIES = ['monthly', 'annual'];

// Asistencia de una sesión. Reagendada es neutra a propósito: no es una falta,
// es una reunión que todavía va a ocurrir.
export const attendanceStatuses = {
  attended:    { color: '#4F7A5F' },
  partial:     { color: '#C9873F' },
  no_show:     { color: '#AE5B61' },
  rescheduled: { color: '#847782' },
};

export const tiers = {
  ENTERPRISE:    { bg: '#F3E9F3', fg: '#531253', label: 'ENTERPRISE' },
  BUSINESS_PLUS: { bg: '#FFF0F0', fg: '#C24B4B', label: 'BUSINESS PLUS' },
  BUSINESS:      { bg: '#EDE6E3', fg: '#6B5F68', label: 'BUSINESS' },
  STARTER:       { bg: '#F0ECEE', fg: '#847782', label: 'STARTER' },
  FREE:          { bg: '#F0ECEE', fg: '#847782', label: 'FREE' },
};

export const theme = createTheme({
  typography: {
    fontFamily: 'Saira, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h5: { fontWeight: 600, letterSpacing: '-0.01em', color: '#170312' },
    h6: { fontWeight: 600, color: '#170312' },
    body1: { fontWeight: 350, fontSize: 15, color: '#170312' },
    body2: { fontWeight: 350, fontSize: 13.5, color: '#170312' },
    button: { fontWeight: 550, letterSpacing: '0.05em', textTransform: 'none' },
  },
  palette: {
    primary: { main: '#FF6666', contrastText: '#FFFFFF' },
    secondary: { main: '#531253', contrastText: '#FFFFFF' },
    error: { main: '#AE5B61' },
    warning: { main: '#C9873F' },
    success: { main: '#4F7A5F' },
    text: { primary: '#170312', secondary: '#847782' },
    background: { default: '#F5F5F5', paper: '#FFFFFF' },
    divider: '#E4E0E2',
  },
  shape: { borderRadius: 5 },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#170312',
          boxShadow: 'none',
          borderBottom: '1px solid #E4E0E2',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none', border: '1px solid #E4E0E2' },
      },
    },
  },
});

export default theme;
